import { render } from "./PosPickupDisplayPage.vue?vue&type=template&id=45ccf9a8&scoped=true&ts=true"
import script from "./PosPickupDisplayPage.vue?vue&type=script&lang=ts"
export * from "./PosPickupDisplayPage.vue?vue&type=script&lang=ts"

import "./PosPickupDisplayPage.vue?vue&type=style&index=0&id=45ccf9a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ccf9a8"]])

export default __exports__